import {
    SET_WEBSOCKET,
  } from '../mutation_types'
  const state = {
    game_new_activity_dji: [],
    game_new_activity_btc: [],
    kline: []
  }
  const mutations = {
    
  }

  export default {
    state,
    mutations
  }
